import GenericDB from "./generic-db";

export default class UsersDB extends GenericDB {
    constructor() {
        // set 'users' inside GenericDB => constructor() => collectionPath = 'users'
        super("users");
    }
    // Here you can extend UserDB with custom methods
}
